import RegisterDepositCard from './RegisterDepositCard';

export default RegisterDepositCard;
